import { render, staticRenderFns } from "./Dossiers.vue?vue&type=template&id=44e6b3bc&scoped=true&"
import script from "./Dossiers.js?vue&type=script&lang=js&"
export * from "./Dossiers.js?vue&type=script&lang=js&"
import style0 from "./Dossiers.vue?vue&type=style&index=0&id=44e6b3bc&scoped=true&lang=css&"
import style1 from "./Dossiers.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Dossiers.vue?vue&type=style&index=2&id=44e6b3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6b3bc",
  null
  
)

export default component.exports